import { GraphQLResult } from "@aws-amplify/api";
import { API } from "aws-amplify";
import { Dispatch,SetStateAction } from "react";
import { toast } from 'react-toastify';

import { listRacks } from "../../../graphql/queries";
import { updateLoading } from "../../../redux/slice/appSlice";
import { AppDispatch } from "../../../redux/store";
import { ListRacksQuery, Rack } from "../../../types/api";

interface getRackDetailListProp {
  dispatch: AppDispatch;
  updateRacks: Dispatch<SetStateAction<(Rack|null)[]>>;
}
export const getRackDetailList: ({
  dispatch,
  updateRacks
}: getRackDetailListProp) => Promise<void> = async ({
  dispatch,
  updateRacks
}: getRackDetailListProp) => {
  try {
    dispatch(updateLoading(true));
    const getResponse: GraphQLResult<ListRacksQuery> = await API.graphql({
      query: listRacks
    }) as GraphQLResult<ListRacksQuery>;
    if (getResponse.data?.listRacks?.items) {
        updateRacks(getResponse.data.listRacks.items);
    }
  } catch (err) {
    // console.log(err)
    toast.dark("Error: Get Rack by ID.");
  } finally {
    dispatch(updateLoading(false));
  }
};
